import { useEffect, useState } from "react";
import { PublicLayout } from "@/components/shared/PublicLayout";
import { SEOHead } from "@/components/shared/SEOHead";
import { BookCallButton } from "@/components/shared/BookCallButton";
import { getComingSoonLocations } from "@/lib/api";
import { MapPin, Loader2 } from "lucide-react";

export default function UpcomingStoresPage() {
  const [stores, setStores] = useState(null);
  useEffect(() => { getComingSoonLocations(true).then((d) => setStores(Array.isArray(d) ? d : d?.locations || [])).catch(() => setStores([])); }, []);
  const byState = (stores || []).reduce((acc, s) => ({ ...acc, [s.state || "Other"]: [...(acc[s.state || "Other"] || []), s] }), {});
  return (
    <PublicLayout>
      <SEOHead pageSlug="upcoming-stores" fallback={{
        meta_title: "Upcoming Total Wireless Stores | Prime Media Wireless",
        meta_description: "See the new Total Wireless stores Prime Media Wireless is opening soon, and learn how to open a Total Wireless store or become a Total Wireless dealer near you.",
      }} />
      <section className="bg-navy py-20" data-testid="upcoming-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
          <p className="label-style text-teal mb-4">Growing nationwide</p>
          <h1 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-white mb-6">Upcoming Total Wireless Stores</h1>
          <p className="text-slate-300 text-base lg:text-lg font-body mb-8">New Total Wireless stores opening soon with Prime Media Wireless. Want the next one to be yours?</p>
          <BookCallButton />
        </div>
      </section>
      <section className="py-16 bg-white" data-testid="upcoming-list">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {stores === null ? <Loader2 className="w-6 h-6 animate-spin text-teal" /> : stores.length === 0 ? (
            <p className="text-slate-600 font-body" data-testid="upcoming-empty">New openings are announced here as soon as they're confirmed. Book a free call to hear about stores coming to your area.</p>
          ) : Object.keys(byState).sort().map((st) => (
            <div key={st} className="mb-10">
              <h2 className="font-heading font-bold text-xl text-navy mb-4">{st}</h2>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {byState[st].map((s) => (
                  <div key={s.id} className="rounded-xl border border-slate-200 p-5" data-testid={`upcoming-store-${s.id}`}>
                    <span className="inline-block mb-2 px-2 py-0.5 rounded-full bg-orange-100 text-orange-700 text-xs font-semibold">Coming soon</span>
                    <p className="font-heading font-semibold text-navy">{s.name}</p>
                    <p className="text-sm text-slate-500 flex items-center gap-1 mt-1"><MapPin className="w-4 h-4" />{s.city}, {s.state}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </PublicLayout>
  );
}
